import * as React from 'react';
import { Header, NavMenu } from "./index";
interface IDefaultLayoutProps {
  fullWidth?: boolean;
  children: any;
}
class DefaultLayout extends React.PureComponent<IDefaultLayoutProps, any> {
  constructor(props) {
    super(props);
  }
  componentWillMount() {}
  componentWillReceiveProps(nextProps: any) {}
  componentDidUpdate(prevProps: any) {}
  componentWillUpdate(nextProps: any) {}
  componentWillUnmount() {}
  render() {
    const {
      fullWidth
    } = this.props;
    return <div data-sentry-component="DefaultLayout" data-sentry-source-file="DefaultLayout.tsx">
            <Header fullWidth={fullWidth} header={'Trial Management'} data-sentry-element="Header" data-sentry-source-file="DefaultLayout.tsx"></Header>
            <NavMenu fullWidth={fullWidth} data-sentry-element="NavMenu" data-sentry-source-file="DefaultLayout.tsx"></NavMenu>
            {this.props.children}
        </div>;
  }
}
export default DefaultLayout;